/**
 * A class that describes data used in a checkbox.
 */
export class CheckboxItem {
  value: string;
  label: string;
  checked: boolean;

  /**
   * @param value A value, used to identify, which checkbox was checked.
   * @param label A label of a checkbox.
   * @param checked `True` if a checkbox is checked.
   */
  constructor(value: any, label: any, checked?: boolean) {
    this.value = value;
    this.label = label;
    this.checked = checked ? checked : false;
  }
}
